import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import EMRDashboard from '../components/EMRDashboard';
import api from '../lib/api';
import { ArrowLeft, Loader2 } from 'lucide-react';

export default function EMRPage() {
  const { clientId } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      navigate('/login');
      return;
    }
    fetchClient();
  }, [user, clientId, navigate]);

  const fetchClient = async () => {
    try {
      const response = await api.get(`/clients/${clientId}`);
      setClient(response.data);
    } catch (error) {
      console.error('Failed to load client:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate('/dashboard');
  };

  if (!user) {
    return null;
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-subtle flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-purple-600" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-subtle">
      {/* Navigation Bar */}
      <nav className="nav-premium sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-8 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <Button
                variant="ghost"
                onClick={handleBack}
                className="text-purple-700 hover:text-purple-900 hover:bg-purple-50"
                data-testid="emr-back-button"
              >
                <ArrowLeft className="w-4 h-4 mr-2" />
                Back to Dashboard
              </Button>
              <div className="border-l border-purple-200 pl-4">
                <h1 className="text-lg font-bold text-purple-900 tracking-tight" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
                  Electronic Medical Record
                </h1>
                {client && (
                  <p className="text-xs text-gray-500 font-medium">
                    {client.first_name} {client.last_name}
                  </p>
                )}
              </div>
            </div>
            <div className="flex items-center gap-5">
              <div className="text-right">
                <p className="text-sm font-semibold text-purple-900">{user?.full_name}</p>
                <p className="text-xs text-gray-500 capitalize font-medium">{user?.role}</p>
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* EMR Content */}
      <main className="max-w-7xl mx-auto px-8 py-6">
        <EMRDashboard clientId={clientId} shiftId={null} />
      </main>
    </div>
  );
}
